// start:ng42.barrel
import   './document-store.service';
import   './components';
// end:ng42.barrel

